<template>
    <LayoutDefault
        variant="white"
        :without-footer="true"
    >
        <div class="background relative" :style="{ backgroundImage: `url(${event && event.cover ? event.cover.cached_full_url : ''})` }">

            <SearchEngine/>

            <router-link
                v-if="event"
                :to="{name: 'event.view', params: {id: event.id, slug: event.slug}}"
                class="absolute left-6 md:right-20 md:left-auto bottom-10 md:bottom-16 border-l-2 border-white pl-4 md:pl-6"
            >
                <h1 class="text-white text-md md:text-xl">{{ event.name }}</h1>
                <span class="text-white opacity-70 text-base md:text-lg">
                    {{ event.finishing_date ? moment(event.finishing_date).format("DD.MM.YYYY") : null }}
                </span>
            </router-link>
        </div>
    </LayoutDefault>
</template>

<script>
import IcSearch from "../../../js-admin/components/svg/IcSearch.vue";
import SearchEngine from "../../components/search/organisms/OrganismSearchEngine.vue";
import LayoutDefault from "../../layouts/LayoutDefault.vue";
import {mapActions} from "vuex";
import moment from "moment/moment";

export default {
    name: 'PageSearchPreview',
    components: {LayoutDefault, SearchEngine, IcSearch},
    data(){
        return{
            event: null,
            moment: moment
        }
    },
    methods: {
        ...mapActions('event', ['getRandom']),
        ...mapActions('search', ['clearSearchResults']),
        getRandomProject() {
            this.getRandom().then((result) =>  this.event = result)
        },
    },
    mounted() {
        this.getRandomProject()
        this.clearSearchResults()
    },
}
</script>

<style lang="scss">
.background{
    @apply w-screen h-[100dvh] bg-gray-700;
    background-size: cover;
    background-position: center;
}
</style>
